<template>
  <div class="m-t m-b">
    <div class="line-height-15">{{ date }}</div>
    <div class="line-height-15 font-color-lighter font-sm">{{ time }}</div>
  </div>
</template>

<script>
import * as utils from "@/utils/utils";
export default {
  data() {
    return {
      date: null,
      time: null
    };
  },
  beforeMount() {
    this.date = utils.dateformat(this.params.data.createdTimeStamp, 'M/DD/YYYY');
    this.time = utils.dateformat(this.params.data.createdTimeStamp, 'h:mm a');
  }

};
</script>
